const settings = {
  name: 'Settings',
  tabs: {
    general: 'General',
    categories: 'Categories',
    tags: 'Tags',
  },
  general: {
    appInfo: 'Application Info',
    systemInfo: 'System Info',
    appName: 'Application Name',
    version: 'Version',
    environment: 'Environment',
    apiUrl: 'API URL',
    framework: 'Framework',
    uiLibrary: 'UI Library',
  },
  fields: {
    name: 'Name',
    description: 'Description',
    status: 'Status',
    color: 'Color',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
  },
  status: {
    active: 'Active',
    inactive: 'Inactive',
  },
};

export default settings;
